import React from 'react';
import { t } from 'i18next';
import { DarkButton } from '../../../components/dark-button';

const SuccessVerification = () => {
	return (
		<div className="d-flex flex-column align-items-center justify-content-center w-100 px-3 mt-4">
			{/* Header */}
			<h2 className="mt-4 mb-4 doc-select-title text-center fw-bold w-75 mx-auto">
				{t('VerificationSuccess')}
				<br />
				{t('successfully')}
			</h2>

			{/* Success Image */}
			<img
				src={process.env.PUBLIC_URL + '/verification-success.png'}
				alt="Success"
				className="img-fluid mt-4"
				style={{ maxWidth: '250px' }}
			/>
		</div>
	);
};

export default SuccessVerification;
